import { Typography } from "@mui/material";

const BaseTableCell = ({ children }) => (
  <Typography
    variant="body2"
    sx={{
      display: "-webkit-box",
      WebkitLineClamp: "2",
      WebkitBoxOrient: "vertical",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "pre-wrap",
      textAlign: "center",
    }}
  >
    {children}
  </Typography>
);

export default BaseTableCell;
